import type { CandidateVacancy } from '../types';

type CandidateNamedReference = NonNullable<
  CandidateVacancy['employmentTypes']
>[number];

export function mockCandidateNamedReference(
  overrides: Partial<CandidateNamedReference> = {}
): CandidateNamedReference {
  return {
    id: 1,
    name: 'Full time',
    slug: 'full-time',
    ...overrides,
  };
}
